module.exports = __webpack_public_path__ + "static/media/providence-3.995e63b0.jpg";